import { useQuery } from "@connectrpc/connect-query";
import { ProductService } from "@viajero/proto/guest/v1";
import { useTranslation } from "react-i18next";
import { isValidId } from "@/lib/id";

/**
 * ProductService.GetProductDetail を connect-query (`@connectrpc/connect-query`) でラップするフック。
 *
 * 商品 (コース) 詳細画面 (/{caseToken}/{shopId}/{productId}) で商品詳細を取得する
 * (JPTP_CANSEI-1258)。`x-case-token` ヘッダは lib/client.ts の caseTokenInterceptor が
 * 付与するため、呼び出し側は shopId / productId のみを意識すればよい。表示言語は現在の
 * i18n 言語をそのまま RPC に渡し、backend 側で該当言語行が無ければ en にフォールバックする。
 *
 * shopId / productId は URL パラメータ (文字列) を受け取り、proto の int64 (bigint) へ変換する。
 * 数値でない場合は無効な ID として問い合わせを無効化する (useGetShopDetail と同様)。
 */
export function useGetProductDetail(shopId: string, productId: string, enabled: boolean) {
  const { i18n } = useTranslation();
  const validIds = isValidId(shopId) && isValidId(productId);
  return useQuery(
    ProductService.method.getProductDetail,
    {
      shopId: validIds ? BigInt(shopId) : 0n,
      productId: validIds ? BigInt(productId) : 0n,
      languageCode: i18n.language,
    },
    { enabled: enabled && validIds },
  );
}
